import React from "react";
import MuiButton, { ButtonProps } from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { buttonSxPropsFn } from "./Button.styles";

export type ButtonVariant = "text" | "outlined" | "contained";

export interface SayButtonProps extends ButtonProps {
  variant?: ButtonVariant;
  disabled?: boolean;
  useBrand?: boolean;
  dragged?: boolean;
  children: React.ReactNode;
  defaultIcon?: boolean; // determine if default icon (Plus) should display, preserve default startIcon functionality,
}

const Button = ({
  variant = "outlined",
  startIcon,
  children,
  disabled,
  defaultIcon,
  useBrand,
  dragged,
  sx,
  ...rest
}: SayButtonProps): JSX.Element => {
  /**
   * Contained uses implied color, text and outlined use sites primary color
   * @returns <AddIcon
   */
  const getIcon = (): React.ReactNode => {
    if ((variant === "text" || variant === "outlined") && !disabled) {
      return <AddIcon color="primary" />;
    } else if (variant === "contained" && disabled) {
      return <AddIcon />;
    }
    return <AddIcon />;
  };
  const icon = defaultIcon ? getIcon() : startIcon;
  const consolidatedButtonStyles = {
    ...buttonSxPropsFn({ useBrand, dragged }),
    ...sx,
  };
  return (
    <MuiButton
      startIcon={icon}
      variant={variant}
      disabled={disabled}
      sx={consolidatedButtonStyles}
      {...rest}
    >
      {children}
    </MuiButton>
  );
};

export default Button;
